import styled from 'styled-components';
import { ReactComponent as Icon } from './HeartFilled.svg';

export const HeartFilled = styled(Icon)`
  fill: currentColor;
  width: 100%;
  height: 100%;
`;
